const generateShare = (uri: string, text: string) => `${uri}${encodeURIComponent(text)}`;

export const whatsAppShareLink = (text: string) => generateShare('https://api.whatsapp.com/send?text=', text);

export const facebookShareLink = (shareLink: string) => `https://www.facebook.com/sharer/sharer.php?u=${shareLink}`;

export const linkedinShareLink = (shareLink: string) => `https://www.linkedin.com/shareArticle?mini=true&url=${shareLink}`;

export const twitterShare = (text: string, url: string) => `https://twitter.com/share?text=${text}&url=${encodeURIComponent(url)}`;
